import { BUSCAR_DAMDFE } from '../../actions/types'

const estadoInicial = {
    id: null,
    dataEmissao: null,
    serie: '',
    modelo: 58,
    numero: null,
    dv: 0,
    totalPesoCargas: null,
    totalValorCargas: null,
    quantidadeCtesVinculados: null,
    tipoEmissao: '1',
    observacoes: '',
    urlQRCode: '',
    cidadeOrigem: { id: null, nome: '', uf: '', nomeComUf: '' },
    cidadeDestino: { id: null, nome: '', uf: '', nomeComUf: '' },
    veiculos: [],
    condutores: [],
    percursosMdfeDto: [],
    ctesVinculados: [],
    empresa: {
        nome: '',
        nomeFantasia: '',
        cnpj: '',
        inscricaoEstadual: '',
        enderecoEmpresaDto: []
    },
    ultimoHistoricoEmissaoMdfe: {
        dataHora: null,
        chaveMdfe: null,
        protocolo: null
    }
}

export default function reducerBuscarDamdfe(state = estadoInicial, action = undefined) {
    switch (action.type) {
        case BUSCAR_DAMDFE: {
            const damdfe = action.payload.data;
            if (damdfe) return damdfe;
            return estadoInicial;
        }
        default:
            return state;
    }
}
